export default __webpack_public_path__ + "static/media/inst_logo_text.ac0bc45f.png";